import { render } from "./ContractsRegulationsView.vue?vue&type=template&id=7d65c6a9"
import script from "./ContractsRegulationsView.vue?vue&type=script&lang=js"
export * from "./ContractsRegulationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__